
export type PropertyError = {
  code: string,
  path: string,
  message: string
}

export type ValidationErrorResult = {
  validationErrors: PropertyError[]
}

const buildValidationErrorResult = (validationErrors: PropertyError[]): ValidationErrorResult => {
  return {
    validationErrors
  }
}

export {
  buildValidationErrorResult
}



// WEBPACK FOOTER //
// ./src/types/validation-error-result.js